__turbopack_context__.v({
  "card": "ServerSupportSLASection-module__bWgjuW__card",
  "delta": "ServerSupportSLASection-module__bWgjuW__delta",
  "desc": "ServerSupportSLASection-module__bWgjuW__desc",
  "eyebrow": "ServerSupportSLASection-module__bWgjuW__eyebrow",
  "glow": "ServerSupportSLASection-module__bWgjuW__glow",
  "good": "ServerSupportSLASection-module__bWgjuW__good",
  "grid": "ServerSupportSLASection-module__bWgjuW__grid",
  "header": "ServerSupportSLASection-module__bWgjuW__header",
  "icon": "ServerSupportSLASection-module__bWgjuW__icon",
  "inner": "ServerSupportSLASection-module__bWgjuW__inner",
  "label": "ServerSupportSLASection-module__bWgjuW__label",
  "lg": "ServerSupportSLASection-module__bWgjuW__lg",
  "note": "ServerSupportSLASection-module__bWgjuW__note",
  "ring": "ServerSupportSLASection-module__bWgjuW__ring",
  "row": "ServerSupportSLASection-module__bWgjuW__row",
  "section": "ServerSupportSLASection-module__bWgjuW__section",
  "sm": "ServerSupportSLASection-module__bWgjuW__sm",
  "title": "ServerSupportSLASection-module__bWgjuW__title",
  "value": "ServerSupportSLASection-module__bWgjuW__value",
});
